import { graphql } from "~/gql";

export const FIND_CUMULATIVE_ACCRUED_FEES_FOR_MATTER = graphql(/* GraphQL */ `
  query FindCumulativeAccruedFeesForMatter($matterId: Float!) {
    findCumulativeAccruedFeesForMatter(matterId: $matterId) {
      date
      amount
    }
  }
`);
